// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"instantFee_mainHeading___2Dbz","fieldWrapper":"instantFee_fieldWrapper__3ccit","label":"instantFee_label__1kA2j","buttonWrapper":"instantFee_buttonWrapper__3cOKv"};